import Http from '@/api/http/';

export default class AiModelInfo extends Http {
  constructor() {
    super();
  }

  /**
   * 获取模型列表
   * @param {string} params.modelName - 模型名称
   */
  aiModelInfo_getList() {
    return super.post('aiModelInfo/getList', ...arguments);
  }

  /**
   * 获取模型详情
   * @param {string} params.id - 模型id
   */
  aiModelInfo_detail() {
    return super.post('aiModelInfo/detail', ...arguments);
  }

  /**
   * 更新模型
   * @param {string} params.id - 模型id
   * @param {number} params.billingUnitPrice - 计费单价
   */
  aiModelInfo_update() {
    return super.post('aiModelInfo/update', ...arguments);
  }
}
